import React, { useState } from 'react'
import { Button, Collapse, notification, Popconfirm } from 'antd'
import { useDispatch } from 'react-redux'
import { DisplayDate } from '../../../../components/_utils/appUtils'
import { RowTable } from '../../../../containers/article/articleView/RowTable'
import Request, { API_URL } from '../../../../request'
// import { generateAndDepositAbstractXml, viewGeneratedAbstractXml } from '../actions'
import { viewGeneratedXml, } from '../actions'
import OnlinePublishAbstractDrawer from '../../views/abstractPages/OnlinePublishAbstractDrawer'

const { Panel } = Collapse

const OnlineAbstractDetails = (props) => {
  let { abstract } = props
  let {
    doiProcessDate,
    finalAbstractAttachmentWithDoi, // Renamed for abstract
    onlinePublishedDate,
    doiNumber,
    doiDepositDate
  } = abstract

  let headerTitle = `Online Abstract ${onlinePublishedDate ? `(${DisplayDate(onlinePublishedDate)})` : ''}`
  let [visiblePublishDrawer, setVisiblePublishDrawer] = useState(false)
  let dispatch = useDispatch()

  let events = {
    show: () => {
      setVisiblePublishDrawer(true)
    },
    hide: () => {
      setVisiblePublishDrawer(false)
    }
  }

  let BtnAction = (event) => {
    events.show()
    event.stopPropagation()
  }

  let doiEvents = {
    viewDoiXml: async (event, abstract) => {
      event.stopPropagation()
      // Make sure viewGeneratedAbstractXml accepts abstractId
      let { success, message, filePath } = await dispatch(viewGeneratedXml({ abstractId: abstract._id }))
      if (success) {
        window.open(`${API_URL}${filePath}`, '_blank')
      }
    },
    // depositDoiXml: async (event, abstract) => {
    //   event.stopPropagation()
    //   // Make sure generateAndDepositAbstractXml accepts abstractId
    //   let { success, message } = await dispatch(generateAndDepositAbstractXml({ abstractId: abstract._id }))
    //   if (success) {
    //     notification.success({
    //       message: message
    //     })
    //     // Adjust this dispatch type if your abstract reducer uses a different loading flag
    //     dispatch({ type: 'START_LOAD_ABSTRACT' })
    //   }
    // }
  }

  let getExtraButton = () => {
    return (
      <React.Fragment>
        {doiProcessDate ? (
          <>
            <Button
              type={'primary'}
              size={'small'}
              onClick={(event) => doiEvents.viewDoiXml(event, abstract)}
            >
              View DOI XML
            </Button>{' '}
            <Popconfirm
              placement='topLeft'
              title={`Are you sure you want to Generate XML?`}
              onConfirm={(event) => doiEvents.depositDoiXml(event, abstract)}
              okText='Yes'
              cancelText='No'
            >
              <Button type={'primary'} size={'small'}>
                Direct Deposit DOI XML
              </Button>
            </Popconfirm>
          </>
        ) : null}
        {' '}
        {doiProcessDate && !onlinePublishedDate ? (
          <Button type={'primary'} size={'small'} onClick={BtnAction}>
            Add
          </Button>
        ) : null}
        {onlinePublishedDate ? (
          <Button type={'primary'} size={'small'} onClick={BtnAction}>
            Edit
          </Button>
        ) : null}
      </React.Fragment>
    )
  }

  return (
    <div>
      <Collapse expandIconPosition={'right'} defaultActiveKey={['1']}>
        <Panel header={headerTitle} key='1' extra={getExtraButton()}>
          <div className={'tableBox striped'}>
            <RowTable
              title={'Date'}
              value={onlinePublishedDate && DisplayDate(onlinePublishedDate)}
            />
            <RowTable
              title={'Insert DOI'}
              value={doiNumber ? doiNumber : null}
            />
            <RowTable
              title={'Abstract with DOI'}
              value={
                finalAbstractAttachmentWithDoi && finalAbstractAttachmentWithDoi.path ? (
                  <a
                    download
                    className='downloadLink'
                    target={'_blank'}
                    href={finalAbstractAttachmentWithDoi.path}
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                ) : 'No Attachment'
              }
            />
            <RowTable
              title={'DOI Deposit Date'}
              value={doiDepositDate ? doiDepositDate : null}
            />
          </div>
        </Panel>
      </Collapse>

      {/* Drawer for Adding/Editing Online Publish Details */}
      {visiblePublishDrawer ? (
        <OnlinePublishAbstractDrawer
          visible={visiblePublishDrawer}
          abstract={abstract}
          edit={!!onlinePublishedDate}
          onClose={() => events.hide()}
        />
      ) : null}
    </div>
  )
}

export default OnlineAbstractDetails